import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CuratedForYouHero from "./sections/CuratedForYouHero";
import OurWork from "./sections/OurWork";
import OurFusionPhilosophy from "./sections/OurFusionPhilosophy";
import OurCulinaryJourney from "./sections/OurCulinaryJourney";
import GuestChronicles from "./sections/GuestChronicles";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CuratedForYouHero />
      <OurWork />
      <OurFusionPhilosophy />
      <OurCulinaryJourney />
      <GuestChronicles />
      <FinalCallToAction />
      <Footer />
    </div>;
}